export const spacing = {
  xs: '5px',
  sm: '10px',
  md: '15px',
  xm: '20px',
  '2xm': '25px',
  lg: '30px',
  xl: '40px',
  '2xl': '50px'
} as const
